import { useState } from "react";
import "./Contact.css";
import contactImg from "./img/about-9.jpg";
import { send } from "emailjs-com";

function Contact() {
  const [toSend, setToSend] = useState({
    from_name: "",
    message: "",
    reply_to: "",
  });
  const [notification, setNotification] = useState(null);

  const onSubmit = (e) => {
    e.preventDefault();
    send("service_8g5ydbo", "template_xdoryu8", toSend, "Ba8xiybbB6WyOHmZs")
      .then((response) => {
        console.log("SUCCESS!", response.status, response.text);
        setNotification("Email sent successfully!");

        // Reset the form fields after successful submission
        setToSend({
          from_name: "",
          message: "",
          reply_to: "",
        });
        setTimeout(() => {
          setNotification(null);
        }, 3000); // 3 seconds delay
      })
      .catch((err) => {
        console.log("FAILED...", err);
        setNotification("Failed to send email. Please try again later.");
        setTimeout(() => {
          setNotification(null);
        }, 5000); // 3 seconds delay
      });
  };

  const handleChange = (e) => {
    setToSend({ ...toSend, [e.target.name]: e.target.value });
  };

  return (
    <div className="contact component__space" id="Contact">
      <div className="row">
        <div className="col__2">
          <div className="contact__box">
            <div className="contact__meta">
              <h1 className="hire__text">Contact Me.</h1>
              <p className="hire__text white">
                I am available for freelance work. Connect with me via phone
              </p>
              <p className="hire__text white">
                <strong>
                  <a className="infoContacts" href="https://wa.me/0755292930">
                    0755 292 930
                  </a>
                </strong>{" "}
                or email{" "}
                <strong>
                  <a
                    className="infoContacts"
                    href="mailto:barakaganai01@gmail.com"
                  >
                    barakaganai01@gmail.com
                  </a>
                </strong>
              </p>
            </div>
            <form className="formBox" onSubmit={onSubmit}>
              <div className="input__box">
                <div className="icon input">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-person-circle"
                    viewBox="0 0 16 16"
                  >
                    <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                    <path
                      fill-rule="evenodd"
                      d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
                    />
                  </svg>
                  <input
                    type="text"
                    name="from_name"
                    placeholder="Enter Your Name..*"
                    value={toSend.from_name}
                    onChange={handleChange}
                    required
                  />
                </div>{" "}
                <br />
                <div className="icon input">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-envelope"
                    viewBox="0 0 16 16"
                  >
                    <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" />
                  </svg>
                  <input
                    type="text"
                    name="reply_to"
                    placeholder="Enter Your email..*"
                    value={toSend.reply_to}
                    onChange={handleChange}
                    required
                  />
                </div>{" "}
                <br />
                <div className="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-chat-left-text"
                    viewBox="0 0 16 16"
                  >
                    <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
                    <path d="M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 6zm0 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z" />
                  </svg>
                  <textarea
                    name="message"
                    placeholder="Write Your Message...*"
                    value={toSend.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>{" "}
                <br />
                <button className="btn contact pointer" type="submit">
                  submit
                </button>
                {notification && (
                  <div className="notification">{notification}</div>
                )}
              </div>
            </form>
          </div>
        </div>
        <div className="col__2">
          <img src={contactImg} alt="" className="contact__img" />
        </div>
      </div>
    </div>
  );
}

export default Contact;
